import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Typography } from "@mui/material";
import html2pdf from "html2pdf.js";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSelect from "../../../../components/Select/Select";
import {
  assignFormByAppointmentIdWoLoader,
  deletePetFromByIdWoLoader,
  getClinicFormsWoLoader,
  updatePetFromByIdWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";

const delBtn = { color: AppColors.red, width: 20, height: 20 };
const eyeBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };

const PetForms = () => {
  const dispatch = useDispatch();
  const pdfRef = useRef(null);
  const sigCanvas = useRef(null);
  const clinicFormFetchedRef = useRef(false);
  const [profileImg, setProfileImg] = useState();
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [vetSignUrl, setVetSignUrl] = useState(null);
  const [addModVsble, setAddModVsble] = useState(false);
  const [formValue, setFormValue] = useState(null);
  const [formErr, setFormErr] = useState(false);
  const [slctedItem, setSlctedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [prevModVsble, setPrevModVsble] = useState(false);
  const [contPrevModVsble, setContPrevModVsble] = useState(false);
  const [signModVsble, setSignModVsble] = useState(false);
  const { forms, details: clinicDet } = useSelector((state) => state?.clinic);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    if (clinicFormFetchedRef.current) return;
    clinicFormFetchedRef.current = true;
    dispatch(getClinicFormsWoLoader());
  }, [dispatch]);

  useEffect(() => {
    if (clinicDet?.image) {
      fetch(clinicDet.image)
        .then((res) => res.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => setProfileImg(reader.result);
        });
    }

    const fetchImage = async () => {
      if (!reqDet?.appointment?.signature) return;
      const res = await fetch(reqDet?.appointment?.signature, {
        method: "GET",
        headers: {},
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setVetSignUrl(url);
    };

    fetchImage();
  }, [clinicDet?.image, reqDet?.appointment?.signature]);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(reqDet?.appointment?.appointmentId),
    );
  };

  const getFormList = () => {
    return forms
      ?.filter((frm) => frm?.documentType === "Form")
      ?.map((cf) => ({ ...cf, value: cf?.formId }));
  };

  const onCloseAddMod = () => {
    setAddModVsble(false);
  };

  const handleSave = (formId) => {
    if (!formId) return setFormErr(true);
    dispatch(
      assignFormByAppointmentIdWoLoader({
        apntId: reqDet?.appointment?.appointmentId,
        formId,
      }),
    ).then((res) => {
      if (res?.payload) {
        callApi();
        setAddModVsble(false);
        setFormValue(null);
        setFormErr(false);
      }
    });
  };

  const onChange = (value) => {
    setFormValue(value);
    setFormErr(!value?.formId);
  };

  const delForm = (dta) => {
    setSlctedItem(dta);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSlctedItem(null);
  };

  const onCofirmDelete = () => {
    if (!slctedItem?.petFormId) return;
    dispatch(deletePetFromByIdWoLoader(slctedItem?.petFormId))?.then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  const onCloseSignMod = () => {
    setSlctedItem(null);
    setSignModVsble(false);
    setContPrevModVsble(false);
    setSignatureUrl(null);
  };

  const handleSignature = () => {
    const newSignature = sigCanvas.current.toDataURL();
    setSignatureUrl(newSignature);
  };

  const onSaveSign = async () => {
    try {
      handleSignature();
      if (!pdfRef.current) return;
      html2pdf()
        .from(pdfRef.current)
        .outputPdf("blob")
        .then((blob) => {
          const form = new FormData();
          form.append("file", blob, `${Date.now()}sign.pdf`);
          dispatch(
            updatePetFromByIdWoLoader({ formId: slctedItem?.petFormId, form }),
          )?.then((res) => {
            if (res?.payload) {
              onCloseSignMod();
              callApi();
            }
          });
        });
    } catch (error) {}
  };

  const handleSign = (dta) => {
    const resCon = forms?.find((frm) => frm?.formId === dta?.formId);
    setSlctedItem({ ...dta, ...(resCon ?? {}) });
    setContPrevModVsble(true);
    // setSignModVsble(true);
  };

  async function downloadFile(url, fileName) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed", err);
    }
  }

  const handleView = async (dta) => {
    setSlctedItem(dta);
    setPrevModVsble(true);
  };

  const onClosePreview = () => {
    setPrevModVsble(false);
    setSlctedItem(null);
  };

  const addEditShow = true;
  // reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed" ||
  // (reqDet?.appointment?.appointmentStatus?.toLowerCase() === "completed" &&
  //   !reqDet?.appointment?.lock);

  return (
    <>
      <div className="ph20 mt10">
        {addModVsble ? (
          <div className="mt10">
            <div className="flex-row">
              <Typography className="blue-color fs14 txt-semi-bold mt5">
                Name :
              </Typography>
              <div className="w70Per ml20">
                <CustomSelect
                  list={getFormList()}
                  value={formValue}
                  error={formErr}
                  helperText={formErr ? "This field is required" : ""}
                  label=""
                  handleChange={(e, value) => handleSave(value?.formId)}
                  search
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="flex-row-ali-cen ph20">
              <div className="w35Per">
                <Typography className="font-bold blue-color fs12">
                  Name
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="font-bold blue-color fs12">
                  Status
                </Typography>
              </div>
              <div className="w40Per" />
            </div>
            <div className="blue-hor-split mt5" />
            {reqDet?.forms?.map((pf) => (
              <div className="flex-row-ali-cen ph20 mt10" key={pf?.petFormId}>
                <div className="w35Per">
                  <Custom3dotString
                    str={pf?.name}
                    className="txt-semi-bold blue-color fs12"
                    length={25}
                  />
                </div>
                <div className="w15Per">
                  <div
                    className={`${
                      pf?.status ? "green-back5" : "red-back2"
                    } ph20 pv5 br5 wdth-max-cnt`}
                  >
                    <Typography className="font-medium fs12 white-color">
                      {pf?.status ? "Signed" : "Pending"}
                    </Typography>
                  </div>
                </div>
                <div className="w50Per">
                  <div className="flex-row-ali-cen">
                    {!pf?.status ? (
                      <div>
                        <CustomButton
                          text="Sign now"
                          smallBtn
                          onClick={() => handleSign(pf)}
                        />
                      </div>
                    ) : null}
                    {/* <div className="ml10">
                    <CustomButton text="Send for Signature" smallBtn />
                  </div> */}
                    <div className="flex1-end">
                      {addEditShow ? (
                        <div className="cursor" onClick={() => delForm(pf)}>
                          <div className="flex-center">
                            <DeleteOutlineIcon sx={delBtn} />
                          </div>
                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                            Delete
                          </Typography>
                        </div>
                      ) : null}
                      {pf?.status ? (
                        <div
                          className="cursor ml20"
                          onClick={() => handleView(pf)}
                        >
                          <div className="flex-center">
                            <VisibilityIcon sx={eyeBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            View
                          </Typography>
                        </div>
                      ) : (
                        <div className="ml40" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {addEditShow ? (
              <div
                className="flex-row-ali-cen mt20 cursor"
                onClick={() => setAddModVsble(true)}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
            ) : null}
          </>
        )}
      </div>

      <div style={{ display: "none" }}>
        <div ref={pdfRef} className="bg ph20 mb20">
          <div className="flex-row-ali-cen mv20">
            <div className="w20Per">
              <div className="pl20">
                <div>
                  {profileImg ? (
                    <img src={profileImg} className="img-h75" alt="" />
                  ) : (
                    <div className="flex-center h50img">
                      <Typography className="font-bold fs30 white-color capitalize">
                        {profile?.name?.[0]}
                      </Typography>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w60Per flex-center">
              <div className="font-bold fs30 blue-color">
                {slctedItem?.name}
              </div>
            </div>
            <div className="w20Per flex1-end">
              <div className="pr10">
                <img
                  src={require("../../../../assets/images/png/VetInstantLogo.png")}
                  alt=""
                  className="wh50 blu-back p5"
                />
              </div>
            </div>
          </div>
          <div className="yellow-bar" />
          <div dangerouslySetInnerHTML={{ __html: slctedItem?.content }} />
          <div className="mt100">
            <div className="flex-row-ali-cen">
              {signatureUrl ? (
                <img src={signatureUrl} alt="" className="h60" />
              ) : null}
              <div className="flex1-end">
                {vetSignUrl ? (
                  <img src={vetSignUrl} alt="" className="h60" />
                ) : null}
              </div>
            </div>
            <div className="flex-row-ali-cen">
              <Typography className="fs16 font-bold black">
                Signature of pet parent
              </Typography>
              <div className="flex1-end">
                <Typography className="fs16 font-bold black">
                  Signature of licensed veterinarian
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete Form"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the form?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={signModVsble || contPrevModVsble}
        onClose={onCloseSignMod}
        header={contPrevModVsble ? "Preview " : "Signature"}
        modal
        modalWidth={70}
      >
        {contPrevModVsble ? (
          <div className="scroll-70vh">
            <div className="bg ph20 mb20">
              <div className="flex-row-ali-cen mv20">
                <div className="w20Per">
                  <div className="pl20">
                    <div>
                      {profileImg ? (
                        <img src={profileImg} className="img-h75" alt="" />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {profile?.name?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w60Per flex-center">
                  <div className="font-bold fs30 blue-color">
                    {slctedItem?.name}
                  </div>
                </div>
                <div className="w20Per flex1-end">
                  <div className="pr10">
                    <img
                      src={require("../../../../assets/images/png/VetInstantLogo.png")}
                      alt=""
                      className="wh50 blu-back p5"
                    />
                  </div>
                </div>
              </div>
              <div className="yellow-bar" />
              <div dangerouslySetInnerHTML={{ __html: slctedItem?.content }} />
              <div className="mt100">
                <div className="flex-row-ali-cen">
                  {signatureUrl ? (
                    <img src={signatureUrl} alt="" className="h60" />
                  ) : null}
                  <div className="flex1-end">
                    {vetSignUrl ? (
                      <img src={vetSignUrl} alt="" className="h60" />
                    ) : null}
                  </div>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="fs16 font-bold black">
                    Signature of pet parent
                  </Typography>
                  <div className="flex1-end">
                    <Typography className="fs16 font-bold black">
                      Signature of licensed veterinarian
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <SignatureCanvas
            ref={sigCanvas}
            canvasProps={{
              width: (window.innerWidth / 100) * 65,
              height: 300,
              className: "sigCanvas",
            }}
          />
        )}
        <div className="flex-center">
          <div>
            <CustomButton
              text={contPrevModVsble ? "Continue to Sign" : "Save"}
              smallBtn
              onClick={() => {
                if (contPrevModVsble) {
                  setContPrevModVsble(false);
                  setSignModVsble(true);
                } else {
                  onSaveSign();
                }
              }}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={prevModVsble}
        onClose={onClosePreview}
        header=""
        modal
        modalWidth={90}
      >
        <div className="scroll-70vh">
          <div className="flex-center">
            <iframe
              className="pdf-prev"
              frameborder="0"
              src={`https://docs.google.com/gview?url=${slctedItem?.file}&embedded=true`}
            />
          </div>
          <div className="flex-center">
            <div className="mt20">
              <CustomButton
                text="Print"
                onClick={() =>
                  downloadFile(slctedItem?.file, `${slctedItem?.name}.pdf`)
                }
                smallBtn
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetForms;
